"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _internal = require("../../theme/internal"); // =============================== Base ===============================


var genBaseStyle = function genBaseStyle(token) {
  var componentCls = token.componentCls,
      colorText = token.colorText,
      fontSize = token.fontSize,
      lineHeight = token.lineHeight,
      fontFamily = token.fontFamily;
  return _defineProperty({}, componentCls, {
    color: colorText,
    fontSize: fontSize,
    lineHeight: lineHeight,
    fontFamily: fontFamily
  });
}; // ============================== Export ==============================


var _default = (0, _internal.genComponentStyleHook)('App', function (token) {
  return [genBaseStyle(token)];
});

exports.default = _default;